/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payouts": {
        "nested": {
          "PayoutStatus": {
            "values": {
              "UNKNOWN_PAYOUT_STATUS_DO_NOT_USE": 0,
              "SENT": 1,
              "FAILED": 2,
              "PAID": 3,
              "PENDING": 4
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payouts?.nested?.PayoutStatus) {
  $root.addJSON(jsonData);
}

/**
 * @desc Payout status types
 *
 * SOURCE PayoutStatus @ squareup/payouts/model.proto at 196:1
 */
export const PayoutStatus = $root.lookupEnum('squareup.payouts.PayoutStatus').values;